import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { PageAction } from '../../../components/page-actions/page-actions.component';

import { Models } from '@ibexfusion/models';
import { RedirectService } from '@services/redirects/redirect.service';
import { ScreenService } from '@services/screens/screen.service';
import { CustomerService } from '@services/customers/customer.service';

@Component({
    selector: 'app-redirect-detail',
    templateUrl: './redirect-detail.component.html',
    styleUrls: ['./redirect-detail.component.scss'],
    providers: [RedirectService, ScreenService, CustomerService],
    standalone: false
})
export class RedirectDetailComponent implements OnInit {

  public params: any;

  public pageActions: PageAction[];

  public redirect: Models.Redirect;
  public redirectUrl: string = null;

  public screen: Models.Screen;

  public customer: Models.Customer;

  public title;

  public subtitle;

  public isLoading: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private redirectService: RedirectService,
    private screenService: ScreenService,
    private customerService: CustomerService,
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    return this.redirectService.get(this.route.snapshot.params['id']).then(response => {
      this.redirect = response;
      this.redirectUrl = 'http://my.ibexfusion.com/r/' + this.redirect.uuid.replace(/-/g, '');
      return this.screenService.find(0, 1, { uuid: this.redirect.screenUUID }).then(responseScreen => {
        this.screen = responseScreen.data[0];
        this.title = 'Redirect from Screen' + this.screen.remark;
        return this.customerService.find(0, 1, { _id: this.screen.customerId }).then(responseCustomer => {
          this.customer = responseCustomer.data[0];
          this.subtitle = 'Customer: ' + this.customer.company;
          this.createPageActions();
          this.isLoading = false;
        });
      });
    });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'edit',
        title: 'Edit Redirect',
        callback: () => {
          this.router.navigate(['redirects', this.route.snapshot.params['id'], 'edit']);
        }
      }),
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Customer',
        callback: () => {
          this.router.navigate(['customers', this.customer._id]);
        }
      }),
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Screen',
        callback: () => {
          this.router.navigate(['screens', this.screen._id]);
        }
      }),
      new PageAction({
        icon: 'receipt',
        title: 'View Logs',
        callback: () => {
          this.router.navigate(['redirects/log', this.redirect.uuid]);
        }
      })
    ];
  }

}
